import React from 'react';
import { buildDate } from '../../utils/scheduleViewHelpers';

const HIGHLIGHT_VARIANTS = ['green', 'rose'];

function EmployeesScheduleTable({
  tableRef,
  employees,
  days,
  year,
  month,
  highlightedEmployeeId,
  onToggleEmployeeHighlight,
  renderDayHeader,
  getCellSchedulesAll,
  getAvailableOptionsForEmployeeCell,
  buildDisplayOptionForEntry,
  updateScheduleCell,
  updateExistingEntryInEmployeeCell,
  calculateEmployeeHours,
  calculateQuarterEmployeeHours,
}) {
  return (
    <div
      ref={tableRef}
      style={{ overflowX: 'auto', maxWidth: '100%' }}
      className="schedule-container"
    >
      <table className="schedule-table">
        <thead>
          <tr>
            <th>Pracownik</th>
            {days.map((day) => renderDayHeader(day))}
            <th>Godziny miesiąc</th>
            <th>Godziny kwartał</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((emp, index) => {
            const isHighlighted =
              highlightedEmployeeId != null &&
              highlightedEmployeeId.toString() === emp.id.toString();
            const highlightVariant = HIGHLIGHT_VARIANTS[index % HIGHLIGHT_VARIANTS.length];
            const rowClass = isHighlighted
              ? `schedule-table__row--highlighted schedule-table__row--highlight-${highlightVariant}`
              : '';

            return (
              <tr key={emp.id} className={rowClass}>
                <td
                  className="schedule-table__name-cell schedule-employee-name"
                  onClick={() => onToggleEmployeeHighlight(emp.id)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onToggleEmployeeHighlight(emp.id);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  aria-pressed={isHighlighted}
                  title={isHighlighted ? 'Odznacz wiersz' : 'Podświetl wiersz'}
                >
                  {emp.last_name} {emp.first_name}
                </td>
                {days.map((day) => {
                  const date = buildDate(year, month, day);
                  const entries = getCellSchedulesAll(emp.id, date);

                  if (entries.length === 0) {
                    const options = getAvailableOptionsForEmployeeCell(emp.id, day);
                    return (
                      <td key={day}>
                        <select
                          value=""
                          onChange={(e) => updateScheduleCell(emp.id, date, e.target.value)}
                        >
                          {options.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </td>
                    );
                  }

                  return (
                    <td key={day}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {entries.map((entry) => {
                          const opt = buildDisplayOptionForEntry(entry);
                          const options = getAvailableOptionsForEmployeeCell(emp.id, day);
                          return (
                            <select
                              key={entry.id || `${opt.value}-${date}`}
                              value={opt.value}
                              onChange={(e) => updateExistingEntryInEmployeeCell(entry, date, e.target.value)}
                            >
                              <option value={opt.value}>{opt.label}</option>
                              <option value={`D:${entry.id}`}>🗑 Usuń ten wpis</option>
                              {options
                                .filter((o) => o.value !== opt.value)
                                .map((o) => (
                                  <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                          );
                        })}
                      </div>
                    </td>
                  );
                })}
                <td>{calculateEmployeeHours(emp.id)}</td>
                <td>{calculateQuarterEmployeeHours(emp.id).toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default EmployeesScheduleTable;
